import React from "react";
import PropTypes from "prop-types";
import styled from "theme/libs/styled";
import { Wrapper as OverlayWrapper } from "theme/components/Overlay/OverlayWrapper";

const Wrapper = styled(OverlayWrapper, { shouldForwardProp: (prop) => ["position"].indexOf(prop) === -1 })`
    top: auto;
    left: auto;
    bottom: auto;
    right: auto;

    ${({ position }) =>
        position === "center" &&
        `
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    `}
`;

const PopupWrapper = ({ children, className, duration, zIndex, position }) => (
    <Wrapper className={className} duration={duration} zIndex={zIndex} position={position}>
        {children}
    </Wrapper>
);

PopupWrapper.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string.isRequired,
    duration: PropTypes.number,
    position: PropTypes.string,
    zIndex: PropTypes.number,
};
PopupWrapper.defaultProps = {
    children: null,
    duration: 350,
    position: "",
    zIndex: 9998,
};

export default PopupWrapper;
